import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import login from '@/components/login'
import home from '@/components/home'
import pic from '@/components/pic'
import open from '@/components/open'
import list from '@/components/list'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'login',
      component:resolve => require(['@/components/login'],resolve),
    },
    {
      path: '/home',
      name: 'home',
      component:resolve => require(['@/components/home'],resolve),
       redirect: '/pic',
      children: [
             {
               path: '/pic',
               name: 'pic',
               component:resolve => require(['@/components/pic'],resolve),
             },
             {
               path: '/open',
               name: 'open',
               component:resolve => require(['@/components/open'],resolve),
             },
						 {
						   path: '/list',
						   name: 'list',
						   component:resolve => require(['@/components/list'],resolve),
						 }
             
             
             

         ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js